import SimulationIndex from '@views/sims/index';
import SimulationShow from '@views/sims/show';
import SimulationSectionShow from '@views/sims/sections/show';
import SimulationFlashcard from '@views/sims/flashcards/show';
import SimulationSectionReview from '@views/sims/sections/review';
import SimulationSectionBreak from '@views/sims/sections/break';
import SimulationPerformance from '@views/sims/performance';
import SimulationResults from '@views/sims/results';
import SimulationsGroupingReview from '@views/sims/grouping-review';

// The following routes are for single section simulations only (i.e. Nursing)
import SimulationIntro from '@views/sims/intro';
import SimulationOutro from '@views/sims/outro';
import ProgressFlashcardComponent from '@views/progress/questions/show';
import SimulationReview from '@views/sims/review';

export default [
  {
    path: '/sims',
    name: 'sims#index',
    component: SimulationIndex,
  },
  {
    path: '/sims/:simId?',
    name: 'sims#show',
    component: SimulationShow,
  },
  {
    path: '/sims/:simId/sections/:sectionId',
    name: 'simSection#show',
    component: SimulationSectionShow,
  },
  {
    path: '/sims/:simId/sections/:sectionId/flashcards/:flashcardId',
    name: 'simSectionFlashcard#show',
    component: SimulationFlashcard,
  },
  {
    path: '/sims/:simId/sections/:sectionId/review',
    name: 'simSection#review',
    component: SimulationSectionReview,
  },
  {
    path: '/sims/:simId/groupings/:groupingId/review',
    name: 'simsGrouping#review',
    component: SimulationsGroupingReview,
  },
  {
    path: '/sims/:simId/groupings/:groupingId/flashcards/:flashcardId/review',
    name: 'simsGroupingFlashcard#review',
    component: SimulationFlashcard,
  },
  {
    path: '/sims/:simId/review',
    name: 'sims#review',
    component: SimulationReview,
  },
  {
    path: '/sims/:simId/sections/:sectionId/break',
    name: 'simSection#break',
    component: SimulationSectionBreak,
  },
  {
    path: '/sims/:simId/performance',
    name: 'sims#performance',
    component: SimulationPerformance,
  },
  {
    path: '/sims/:simId/intro/:pageNum',
    name: 'sims#intro',
    component: SimulationIntro,
  },
  {
    path: '/sims/:simId/outro',
    name: 'sims#outro',
    component: SimulationOutro,
  },
  {
    path: '/sims/:simId/flashcards/:flashcardId',
    name: 'simFlashcard#show',
    component: SimulationFlashcard,
  },
  {
    path: '/sims/:categoryId/results/:blueprintId/',
    name: 'sims#results',
    component: SimulationResults,
    meta: {
      header: true,
      simulation: true,
    },
  },
  {
    path: '/sims/:categoryId/results/:blueprintId/:flashcardId',
    component: ProgressFlashcardComponent,
    name: 'sims#results#question',
    meta: {
      header: true,
      masteryFooter: true,
      simulation: true,
    },
  },
  {
    path: '/sims/:categoryId/sections/:sectionId/results/',
    name: 'sims#sectionResults',
    component: SimulationResults,
    meta: {
      header: true,
      simulation: true,
    },
  },
  {
    path: '/sims/:categoryId/results/section/:sectionId/:flashcardId',
    component: ProgressFlashcardComponent,
    name: 'sims#sectionResults#question',
    meta: {
      header: true,
      masteryFooter: true,
      simulation: true,
    },
  },

];
